// validation.js
export const validateField = (field, value) => {
    let error = '';
    switch (field) {
        case 'name':
        case 'address':
        case 'planReviewType':
            if (!value) error = `${toReadableFormat(field)} is required`;
            break;
        case 'email':
        case 'communityEmailAddress':
            const emailRegex = /^\S+@\S+\.\S+$/;
            if (!value) error = 'Email is required';
            else if (!emailRegex.test(value)) error = 'Invalid email format';
            break;
        case 'zip':
        case 'zipcode':
            if (!value) error = 'Zip code is required';
            else if (!/^\d+$/.test(value)) error = 'Zip code must be numeric';
            break;
        case 'phoneNumber':
            if (!value) error = 'Phone number is required';
            else {
                // Remove dashes and check if we have exactly 10 digits
                const digitsOnly = value.replace(/\D/g, '');
                if (digitsOnly.length !== 10) {
                    error = 'Phone number must be 10 digits (e.g., 630-408-9149)';
                } else if (!/^[0-9]{10}$/.test(digitsOnly)) {
                    error = 'Phone number must be valid (e.g., 630-408-9149)';
                }
            }
            break;
        case 'individualName':
            if (!value) error = `Individual Name is required`;
            break;    
        case 'cost':
            if (!value) error = `Estimated Cost is required`;
            else if (value <= 0) {
                error = "Estimated Cost must be a positive number";
              } else if (isNaN(value)) {
                error = "Estimated Cost must be a valid number";
              }
            break;     
        case 'comments':
        case 'description':
            if (!value) error = `${toReadableFormat(field)} is required`;    
            else if (value && value.length < 10) error = `Please add at least 10 characters for ${field}`;
            break;   
        default:
            break;
    }
    return error;
};


const toReadableFormat = (str) => {
    return str
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (match) => match.toUpperCase())
        .trim();
};
